import React, { useEffect } from 'react';
import ReviewPresent from './ReviewPresenter';

import useQueryString from '@hooks/useQueryString';
import { useHistory } from 'react-router-dom';
import { reviewType, ReviewType } from './types';

const ReviewContainer = () => {
  const history = useHistory();

  const {
    query: { type }
  } = useQueryString<{ type: ReviewType }>();

  useEffect(() => {
    if (!type) {
      history.push(`${history.location.pathname}?type=${reviewType.writeable}`);
    }
  }, [history, type]);

  return <ReviewPresent reviewType={type ?? 'writeable'} />;
};

export default ReviewContainer;
